// Regra do "Contrato assinado" nos checklists de admissão e rescisão.
// Espelha o backend (_contrato_obrigatorio / CONTRATO_JANELA_DIAS): processo
// recente exige o PDF anexado — e por isso NÃO oferece a saída 'Não se aplica'.
// Processo antigo não trava o operador (não haverá PDF retroativo).

export const CONTRATO_JANELA_DIAS = 7;

// aceita 'DD/MM/AAAA' (formato das telas) ou 'AAAA-MM-DD'
const paraData = (v) => {
  if (!v) return null;
  const s = String(v).trim();
  let m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
  m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  return null;
};

// PJ e autônomo ficam de fora: prestam serviço por contrato próprio, que não
// passa pelo checklist do DP. Espelha _CONTRATO_VINCULOS_ISENTOS no backend.
export const contratoExigeVinculo = (vinculo) => {
  const s = String(vinculo || '').trim();
  if (!s) return true;   // sem vínculo conhecido, trata como CLT
  return !/pessoa\s*jur/i.test(s) && !/^pj$/i.test(s) && !/aut[oô]nomo/i.test(s);
};

// o contrato é obrigatório para este processo? (sem data conhecida, não é —
// mesma decisão do backend, para não travar registro antigo/importado)
export const contratoExigido = (dataProcesso, vinculo) => {
  if (!contratoExigeVinculo(vinculo)) return false;
  const d = paraData(dataProcesso);
  if (!d) return false;
  const corte = new Date();
  corte.setHours(0, 0, 0, 0);
  corte.setDate(corte.getDate() - CONTRATO_JANELA_DIAS);
  return d >= corte;
};
